import type { AuditTrailItem } from '../project/components/dashboard/auditTrail/auditTrailTypes';
import {
  formatAuditTrailDateTime,
  getActorDisplay,
  getAuditSummary,
  getEventDisplayLabel,
  getModuleLabel,
  getSeverityLabel,
} from '../project/components/dashboard/auditTrail/auditTrailConstants';

function escapeCsvCell(value: string): string {
  if (value.includes('"') || value.includes(',') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function cell(value: string | number | null | undefined): string {
  return escapeCsvCell(value == null || value === '' ? '' : String(value));
}

/** Export audit trail rows to CSV and trigger browser download. */
export function downloadAuditTrailCsv(items: AuditTrailItem[], filename?: string): void {
  const headers = [
    'When',
    'Summary',
    'Severity',
    'Module',
    'Event',
    'Actor',
    'Actor Email',
    'Entity',
    'Entity Type',
    'Project',
    'Session ID',
  ];

  const rows = items.map((row) => {
    const actor = getActorDisplay(row);
    return [
      formatAuditTrailDateTime(row.created_at),
      getAuditSummary(row),
      getSeverityLabel(row.severity),
      getModuleLabel(row.module),
      getEventDisplayLabel(row),
      actor.primary,
      row.actor_email ?? '',
      row.entity_name || row.entity_id || '',
      row.entity_type ?? '',
      row.project_name || (row.project_id != null ? String(row.project_id) : ''),
      row.session_id ?? '',
    ].map(cell);
  });

  const csv = [headers.map(cell).join(','), ...rows.map((r) => r.join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename ?? `audit-trail-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
